/* Marvex — cart upsell carousel. Suggests products from a chosen collection
   (default: accessories), excludes items already in cart, quick-adds via Dawn. */
(function () {
  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  class MxCartUpsell extends HTMLElement {
    connectedCallback() {
      this.collection = this.getAttribute('data-collection') || 'accessories';
      this.limit = parseInt(this.getAttribute('data-limit') || '10', 10);
      this.heading = this.getAttribute('data-heading') || '';
      if (!this._bound) { this.addEventListener('click', this.onClick.bind(this)); this._bound = true; }
      this.load();
    }

    load() {
      var self = this;
      Promise.all([
        fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }),
        fetch('/collections/' + this.collection + '/products.json?limit=50').then(function (r) { return r.json(); })
      ]).then(function (res) {
        var inCart = {};
        (res[0].items || []).forEach(function (i) { inCart[i.product_id] = true; });
        var products = (res[1].products || []).filter(function (p) { return !inCart[p.id]; }).slice(0, self.limit);
        if (!products.length) { self.hidden = true; return; }
        self.render(products);
        self.hidden = false;
      }).catch(function () { self.hidden = true; });
    }

    render(products) {
      var cards = products.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) return '';
        var img = (p.images && p.images[0]) ? p.images[0].src : '';
        var price = money(Math.round(parseFloat(v.price) * 100));
        var url = '/products/' + p.handle;
        return '<div class="mx-upsell__card">'
          + '<a href="' + url + '" class="mx-upsell__media">' + (img ? '<img class="mx-upsell__img" src="' + sized(img, 200) + '" alt="" loading="lazy">' : '') + '</a>'
          + '<div class="mx-upsell__info">'
          + '<a href="' + url + '" class="mx-upsell__name">' + esc(p.title) + '</a>'
          + '<span class="mx-upsell__price">' + price + '</span>'
          + '</div>'
          + '<button type="button" class="mx-upsell__add" data-mx-upsell-add data-variant-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + (v.available ? '+ Add' : 'Sold out') + '</button>'
          + '</div>';
      }).join('');
      this.innerHTML = '<div class="mx-upsell">'
        + (this.heading ? '<p class="mx-upsell__title">' + esc(this.heading) + '</p>' : '')
        + '<div class="mx-upsell__list">' + cards + '</div></div>';
    }

    onClick(e) {
      var btn = e.target.closest('[data-mx-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      var cartDrawer = document.querySelector('cart-drawer');
      var sections = cartDrawer && cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (cartDrawer && cartDrawer.renderContents && res.sections) { cartDrawer.renderContents(res); }
          else if (document.body.classList.contains('template-cart')) { window.location.reload(); }
          else { window.location.href = '/cart'; }
          btn.textContent = 'Added ✓';
        })
        .catch(function () { btn.textContent = original; btn.disabled = false; });
    }
  }

  if (!customElements.get('mx-cart-upsell')) {
    customElements.define('mx-cart-upsell', MxCartUpsell);
  }
})();
